import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  material: yup.string().required(),
  quantity: yup.number().required()
})
